import React, { lazy } from 'react';
import Confirmation from 'pages/public/Confirmation';
import SignUp from 'pages/public/Signup';
import Login from 'pages/public/Login';
import ResetPassword from 'pages/public/ResetPassowrd';
import { RoutesNames } from './RoutesNames';

const Profile = lazy(() => import('pages/private/Profile'));
const PropertiesPage = lazy(() => import('pages/private/Properties'));
const Residents = lazy(() => import('pages/private/Residents/ResidentsTable'));
const ResidentsDetails = lazy(() => import('pages/private/Residents/ResidentDetails'));
const Animals = lazy(() => import('pages/private/Animals/'));

const CurrentAndMovedOutAnimalDetails = lazy(() => import('pages/private/Animals/CurrentAndMovedOutAnimalDetails'));
const ApplicantAnimalDetail = lazy(() => import('pages/private/Animals/ApplicantAnimalDetail'));
const AnimalsVisitationDetails = lazy(() => import('pages/private/Animals/VisitationAnimalDetail'));
const VisitationsAnimals = lazy(() => import('pages/private/Animals/AnimalsTable/VisitationsTable'));
const PropertyManagers = lazy(() => import('pages/private/PropertyManagers/PropertyManagersTable'));
const PropertyManager = lazy(() => import('pages/private/PropertyManagers/PropertyManagersDetails'));
const Support = lazy(() => import('pages/private/SupportPM'));
const Policy = lazy(() => import('pages/private/Policy'));
const Property = lazy(() => import('pages/private/Properties/PropertiesDetails'));
const IntegrationPage = lazy(() => import('pages/private/Integration'));
const PaymentSettings = lazy(() => import('pages/private/Settings/PaymentSettings'));
const Dashboard = lazy(() => import('pages/private/Dashboard'));
const Curriculum = lazy(() => import('pages/private/Curriculum'));
const SubCurriculum = lazy(() => import('pages/private/Curriculum/SubCurriculum'));
const CurriculumDetail = lazy(() => import('pages/private/Curriculum/CurriculumDetail'));
const Complaints = lazy(() => import('pages/private/Complaints/ComplaintsList'));
const ComplaintDetails = lazy(() => import('pages/private/Complaints/ComplaintsDetails/ComplaintDetails'));
const NoticeDetails = lazy(() => import('pages/private/Complaints/ComplaintsDetails/NoticeDetails'));
const AllRoommates = lazy(() => import('pages/private/AllRoommates/YardiAllRoommates'));
const LeaseDetails = lazy(() => import('pages/private/AllRoommates/YardiAllRoommates'));
const Notificiations = lazy(() => import('pages/private/Settings/Notifications'));
const AccountSettings = lazy(() => import('pages/private/Settings/AccountSettings'));
const Reporting = lazy(() => import('pages/private/Reporting'));
const PropertyReportConfig = lazy(() => import('pages/private/Reporting/PropertyReportConfig'));
const Authentication = lazy(() => import('pages/private/Settings/Authentication'));
const AzureSsoConfigure = lazy(() => import('pages/private/Settings/Authentication/AzureSsoConfigure'));
const Scim = lazy(() => import('pages/private/Settings/Scim'));

export const allowedUserTypes = {
  landlord: 'landlord',
  propertyManager: 'propertyManager',
};

const { landlord, propertyManager } = allowedUserTypes;

export const RoutesData = [
  {
    path: RoutesNames.Profile,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: Profile,
  },
  {
    path: RoutesNames.IndividualProperty,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: Property,
  },
  {
    path: RoutesNames.Properties,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: PropertiesPage,
  },
  {
    path: RoutesNames.PropertyConfigs,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: PropertiesPage,
  },
  {
    path: RoutesNames.SignUpAccessCodes,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: PropertiesPage,
  },
  {
    path: RoutesNames.AnimalsVisitation,
    isPrivate: true,
    exact: true,
    allowedUserTypes: [landlord, propertyManager],
    component: VisitationsAnimals,
  },
  {
    path: RoutesNames.AnimalsVisitationDetails,
    isPrivate: true,
    exact: true,
    allowedUserTypes: [landlord, propertyManager],
    component: AnimalsVisitationDetails,
  },
  {
    path: RoutesNames.Residents,
    isPrivate: true,
    exact: true,
    allowedUserTypes: [landlord, propertyManager],
    component: Residents,
  },
  {
    path: RoutesNames.ResidentDetails,
    isPrivate: true,
    exact: true,
    allowedUserTypes: [landlord, propertyManager],
    component: ResidentsDetails,
  },
  {
    path: RoutesNames.Animals,
    isPrivate: true,
    exact: true,
    allowedUserTypes: [landlord, propertyManager],
    component: Animals,
  },
  {
    path: RoutesNames.AnimalCurrentDetails,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: CurrentAndMovedOutAnimalDetails,
  },
  {
    path: RoutesNames.AnimalMovedOutDetails,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: CurrentAndMovedOutAnimalDetails,
  },
  {
    path: RoutesNames.AnimalApplicantDetails,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: ApplicantAnimalDetail,
  },
  {
    path: RoutesNames.AnimalsAll,
    isPrivate: true,
    exact: true,
    allowedUserTypes: [landlord, propertyManager],
    component: Animals,
  },
  {
    path: RoutesNames.AnimalsCurrent,
    isPrivate: true,
    exact: true,
    allowedUserTypes: [landlord, propertyManager],
    component: Animals,
  },
  {
    path: RoutesNames.AnimalsMovedOut,
    isPrivate: true,
    exact: true,
    allowedUserTypes: [landlord, propertyManager],
    component: Animals,
  },
  {
    path: RoutesNames.AnimalsApplicant,
    isPrivate: true,
    exact: true,
    allowedUserTypes: [landlord, propertyManager],
    component: Animals,
  },
  {
    path: RoutesNames.PropertyManagers,
    isPrivate: true,
    exact: true,
    allowedUserTypes: [landlord, propertyManager],
    component: PropertyManagers,
  },
  {
    path: RoutesNames.PropertyManager,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: PropertyManager,
  },
  {
    path: RoutesNames.Support,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: Support,
  },
  {
    path: RoutesNames.Curriculum,
    isPrivate: true,
    exact: true,
    allowedUserTypes: [landlord, propertyManager],
    component: Curriculum,
  },
  {
    path: RoutesNames.SubCurriculum,
    isPrivate: true,
    exact: true,
    allowedUserTypes: [landlord, propertyManager],
    component: SubCurriculum,
  },
  {
    path: RoutesNames.CurriculumDetail,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: CurriculumDetail,
  },
  {
    path: RoutesNames.Policies,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: Policy,
  },
  {
    path: RoutesNames.Payment,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: PaymentSettings,
  },
  {
    path: RoutesNames.PropertyIntegration,
    isPrivate: true,
    allowedUserTypes: [landlord],
    component: IntegrationPage,
  },
  {
    path: RoutesNames.Integrations,
    isPrivate: true,
    allowedUserTypes: [landlord],
    component: IntegrationPage,
  },
  {
    path: RoutesNames.Dashboard,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: Dashboard,
  },
  {
    path: RoutesNames.Complaints,
    isPrivate: true,
    exact: true,
    allowedUserTypes: [landlord, propertyManager],
    component: Complaints,
  },
  {
    path: RoutesNames.Complaint,
    isPrivate: true,
    exact: true,
    allowedUserTypes: [landlord, propertyManager],
    component: Complaints,
  },
  {
    path: RoutesNames.Notice,
    isPrivate: true,
    exact: true,
    allowedUserTypes: [landlord, propertyManager],
    component: Complaints,
  },
  {
    path: RoutesNames.ComplaintDetails,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: ComplaintDetails,
  },
  {
    path: RoutesNames.NoticeDetails,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: NoticeDetails,
  },
  {
    path: RoutesNames.ResetPassword,
    exact: true,
    component: ResetPassword,
  },
  {
    path: RoutesNames.Confirmation,
    exact: true,
    component: Confirmation,
  },
  {
    path: RoutesNames.SignIn,
    exact: true,
    component: Login,
  },
  {
    path: RoutesNames.SignUp,
    exact: true,
    component: SignUp,
  },
  {
    path: RoutesNames.AllRoommates,
    isGlobal: true,
    component: AllRoommates,
  },
  {
    path: RoutesNames.LeaseDetails,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: LeaseDetails,
  },
  {
    path: RoutesNames.Notifications,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: Notificiations,
  },
  {
    path: RoutesNames.AccountSettings,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: AccountSettings,
  },
  {
    path: RoutesNames.Reporting,
    isPrivate: true,
    exact: true,
    allowedUserTypes: [landlord, propertyManager],
    component: Reporting,
  },
  {
    path: RoutesNames.PropertyReportConfig,
    isPrivate: true,
    allowedUserTypes: [landlord, propertyManager],
    component: PropertyReportConfig,
  },
  {
    path: RoutesNames.AzureSsoConfigure,
    isPrivate: true,
    allowedUserTypes: [landlord],
    component: AzureSsoConfigure,
  },
  {
    path: RoutesNames.ScimSettings,
    isPrivate: true,
    allowedUserTypes: [landlord],
    component: Scim,
  },
  {
    path: RoutesNames.Authentication,
    isPrivate: true,
    allowedUserTypes: [landlord],
    component: Authentication,
  },
];
